/**
 * APIKEY provider catalog — gateways family (aggregators, multi-model routers & API marketplaces).
 * Pure data; merged by apikey/index.ts via spread (god-file decomposition; semantic split).
 */
export const APIKEY_PROVIDERS_GATEWAYS = {
  "charm-hyper": {
    id: "charm-hyper",
    alias: "charm-hyper",
    name: "Charm Hyper",
    icon: "router",
    color: "#7C3AED",
    textIcon: "CH",
    passthroughModels: true,
    website: "https://hyper.charm.land",
    hasFree: true,
    freeNote: "100 free monthly Hypercredits on signup",
    apiHint: "Create an API key at https://hyper.charm.land, then paste it here as a Bearer token.",
  },
  agentrouter: {
    id: "agentrouter",
    alias: "agentrouter",
    name: "AgentRouter",
    icon: "router",
    color: "#10B981",
    textIcon: "AR",
    passthroughModels: true,
    website: "https://agentrouter.org",
    hasFree: true,
    freeNote: "$200 free credits on signup - multi-model routing gateway",
    apiHint: "Get $200 free credits at https://agentrouter.org/register — no credit card required.",
  },
  "command-code": {
    id: "command-code",
    alias: "cmd",
    name: "Command Code",
    icon: "terminal",
    color: "#111827",
    textIcon: "CC",
    website: "https://commandcode.ai/",
    authHint:
      "Use a Command Code API key. Requests are sent to Command Code's /alpha/generate endpoint.",
    apiHint: "Create or copy an API key from Command Code, then paste it here as a Bearer token.",
  },
  openrouter: {
    id: "openrouter",
    alias: "openrouter",
    name: "OpenRouter",
    icon: "router",
    color: "#F97316",
    textIcon: "OR",
    passthroughModels: true,
    website: "https://openrouter.ai",
    hasFree: true,
    freeNote: "Free models at $0/token with :free suffix - 20 RPM / 200 RPD",
  },
  requesty: {
    id: "requesty",
    alias: "requesty",
    name: "Requesty",
    icon: "router",
    color: "#6366F1",
    textIcon: "RQ",
    passthroughModels: true,
    website: "https://requesty.ai",
    hasFree: true,
    freeNote: "Free tier ~200 requests/day - multi-model routing gateway (300+ models)",
    apiHint:
      "Create an API key at https://app.requesty.ai, then paste it here as a Bearer token. " +
      "OpenAI-compatible endpoint at https://router.requesty.ai/v1, with a live /v1/models catalog.",
  },
  dgrid: {
    id: "dgrid",
    alias: "dgrid",
    name: "DGrid",
    icon: "router",
    color: "#65A30D",
    textIcon: "DG",
    passthroughModels: true,
    website: "https://dgrid.ai",
    hasFree: true,
    freeNote:
      "DGrid Free Models Router: 10 requests/minute and 100 requests/day. " +
      "A $5 lifetime top-up unlocks up to 20 requests/minute and 1,000 requests/day.",
    apiHint:
      "Create a DGrid API key at https://dgrid.ai, then use https://api.dgrid.ai/v1 " +
      "as the OpenAI-compatible base URL.",
  },
  qiniu: {
    id: "qiniu",
    alias: "qiniu",
    name: "Qiniu",
    icon: "cloud",
    color: "#1E88E5",
    textIcon: "QN",
    passthroughModels: true,
    website: "https://www.qiniu.com",
    apiHint:
      "Create a Qiniu AI inference API key at https://portal.qiniu.com/ai-inference/api-key, " +
      "then paste it here as a Bearer token. OpenAI-compatible endpoint " +
      "at https://api.qnaigc.com/v1, proxying DeepSeek, Claude, Kimi and more behind one key.",
  },
  orcarouter: {
    id: "orcarouter",
    alias: "orcarouter",
    name: "OrcaRouter",
    icon: "router",
    color: "#0891B2",
    textIcon: "ORC",
    passthroughModels: true,
    website: "https://www.orcarouter.ai",
    apiHint:
      "Create an API key (starts with sk-orca-) at https://www.orcarouter.ai, then paste it as a Bearer token. OpenAI-compatible endpoint at https://api.orcarouter.ai/v1.",
  },
  "api-airforce": {
    id: "api-airforce",
    alias: "af",
    name: "Api.airforce",
    icon: "flight",
    color: "#1E3A5F",
    textIcon: "AF",
    website: "https://api.airforce",
    hasFree: true,
    freeNote:
      "55 free tier models including Grok-3, Claude 3.7, Qwen3, Kimi-K2, Gemini 2.5 Flash, DeepSeek-V3",
    apiHint:
      "Get your API key from https://panel.api.airforce — OpenAI-compatible endpoint at https://api.airforce/v1",
  },
  crof: {
    id: "crof",
    alias: "crof",
    name: "CrofAI",
    icon: "auto_awesome",
    color: "#0EA5E9",
    textIcon: "CR",
    website: "https://crof.ai",
  },
  bazaarlink: {
    id: "bazaarlink",
    alias: "bzl",
    name: "BazaarLink",
    icon: "storefront",
    color: "#6366F1",
    textIcon: "BZ",
    website: "https://bazaarlink.ai",
    hasFree: true,
    freeNote:
      "Free tier: 4M tokens/day per account with auto:free routing — zero-cost inference, no credit card required.",
    authHint:
      "Use your BazaarLink API key (starts with sk-bl-) in Authorization: Bearer <key>. OpenAI SDK works with base URL https://bazaarlink.ai/api/v1. Models use provider/model-name format.",
    apiHint:
      "Create a free API key at https://bazaarlink.ai — model 'auto:free' routes to zero-cost inference. All models use the provider/model-name format, e.g. xiaomi/mimo-v2.5-pro.",
  },
  synthetic: {
    id: "synthetic",
    alias: "synthetic",
    name: "Synthetic",
    icon: "verified_user",
    color: "#6366F1",
    textIcon: "SY",
    website: "https://synthetic.new",
    passthroughModels: true,
  },
  "kilo-gateway": {
    id: "kilo-gateway",
    alias: "kg",
    name: "Kilo Gateway",
    icon: "hub",
    color: "#617A91",
    textIcon: "KG",
    website: "https://kilo.ai",
    passthroughModels: true,
  },
  wafer: {
    id: "wafer",
    alias: "wafer",
    name: "Wafer AI",
    icon: "layers",
    color: "#6366F1",
    textIcon: "WF",
    website: "https://wafer.ai",
    apiHint: "API key from https://wafer.ai",
  },
  "opencode-zen": {
    id: "opencode-zen",
    alias: "opencode-zen",
    name: "OpenCode Zen",
    icon: "opencode",
    color: "#6366f1",
    website: "https://opencode.ai/zen",
    anonymousFallback: true,
  },
  "opencode-go": {
    id: "opencode-go",
    alias: "opencode-go",
    name: "OpenCode Go",
    icon: "opencode",
    color: "#6366f1",
    website: "https://opencode.ai/go",
    anonymousFallback: true,
  },
  puter: {
    id: "puter",
    alias: "pu",
    name: "Puter AI",
    icon: "cloud_circle",
    color: "#6366F1",
    textIcon: "PU",
    website: "https://puter.com",
    hasFree: true,
    freeNote:
      "500+ models (GPT-5, Claude Opus 4, Gemini 3 Pro, Grok 4, DeepSeek V3...) — Users pay via free Puter account",
    passthroughModels: true,
    authHint: "Get token at puter.com/dashboard → Copy Auth Token",
  },
  uncloseai: {
    id: "uncloseai",
    alias: "unc",
    name: "UncloseAI",
    icon: "auto_awesome",
    color: "#8B5CF6",
    textIcon: "UN",
    website: "https://uncloseai.com",
    hasFree: true,
    freeNote: "Free forever — no signup, no credit card. OpenAI-compatible endpoints.",
    passthroughModels: true,
    authHint: "No auth required. API accepts any non-empty string as key for identification.",
  },
  hackclub: {
    id: "hackclub",
    alias: "hc",
    name: "Hackclub AI",
    icon: "auto_awesome",
    color: "#FF6B00",
    textIcon: "HC",
    website: "https://ai.hackclub.com",
    hasFree: true,
    freeNote: "Free AI for Hack Club members — 30+ models, no credit card.",
    passthroughModels: true,
    authHint: "Sign in with your Hack Club account at ai.hackclub.com.",
  },
  "vercel-ai-gateway": {
    id: "vercel-ai-gateway",
    alias: "vag",
    name: "Vercel AI Gateway",
    icon: "route",
    color: "#111827",
    textIcon: "VAI",
    website: "https://vercel.com/docs/ai-gateway",
  },
  llm7: {
    id: "llm7",
    alias: "llm7",
    name: "LLM7.io",
    icon: "hub",
    color: "#6366F1",
    textIcon: "LM",
    website: "https://llm7.io",
    hasFree: true,
    freeNote: "No signup required - 2 req/s, 20 RPM, 100 req/hr free tier",
    apiHint:
      "Works without API key (use 'unused' as key). Get free token at token.llm7.io for higher limits.",
  },
  llamagate: {
    id: "llamagate",
    alias: "llamagate",
    name: "LlamaGate",
    icon: "gate",
    color: "#16A34A",
    textIcon: "LG",
    website: "https://llamagate.ai",
  },
  gitlawb: {
    id: "gitlawb",
    alias: "glb",
    name: "Gitlawb Opengateway (MiMo)",
    icon: "hub",
    color: "#10B981",
    textIcon: "GLB",
    website: "https://opengateway.gitlawb.com",
    hasFree: false,
    freeNote:
      "Free MiMo (xiaomi/mimo-v2.5) revoked 2026-05 — Opengateway is now a pay-as-you-go credit gateway; no recurring free model.",
    apiHint: "Get your API key from Gitlawb Opengateway dashboard.",
  },
  "gitlawb-gmi": {
    id: "gitlawb-gmi",
    alias: "glb-gmi",
    name: "Gitlawb Opengateway (GMI Cloud)",
    icon: "hub",
    color: "#10B981",
    textIcon: "GMI",
    website: "https://opengateway.gitlawb.com",
    hasFree: false,
    freeNote:
      "Free Nemotron promo ended 2026-06 — the GMI Cloud route is now pay-as-you-go credit only.",
    apiHint: "Get your API key from Gitlawb Opengateway dashboard.",
  },
  nanogpt: {
    id: "nanogpt",
    alias: "nanogpt",
    name: "NanoGPT",
    icon: "chat",
    color: "#4F46E5",
    textIcon: "NG",
    website: "https://nano-gpt.com",
  },
  aimlapi: {
    id: "aimlapi",
    alias: "aiml",
    name: "AI/ML API",
    icon: "hub",
    color: "#6366F1",
    textIcon: "AI",
    website: "https://aimlapi.com",
    hasFree: false,
    freeNote:
      "Free tier paused (2026) — AI/ML API is now pay-as-you-go only (min $20 top-up); no recurring free credits.",
    passthroughModels: true,
  },
  novita: {
    id: "novita",
    alias: "novita",
    name: "Novita AI",
    icon: "auto_awesome",
    color: "#FF4081",
    textIcon: "NV",
    website: "https://novita.ai",
    hasFree: true,
    freeNote: "$0.50 trial credits on signup (valid about 1 year)",
    passthroughModels: true,
  },
  piapi: {
    id: "piapi",
    alias: "pi",
    name: "PiAPI",
    icon: "api",
    color: "#7C4DFF",
    textIcon: "PI",
    website: "https://piapi.ai",
    passthroughModels: true,
  },
  getgoapi: {
    id: "getgoapi",
    alias: "ggo",
    name: "GoAPI",
    icon: "rocket_launch",
    color: "#FF6D00",
    textIcon: "GO",
    website: "https://api.getgoapi.com",
    passthroughModels: true,
  },
  laozhang: {
    id: "laozhang",
    alias: "lz",
    name: "LaoZhang AI",
    icon: "hub",
    color: "#FF1744",
    textIcon: "LZ",
    website: "https://api.laozhang.ai",
    passthroughModels: true,
  },
  thebai: {
    id: "thebai",
    alias: "thebai",
    name: "TheB.AI",
    icon: "hub",
    color: "#3B82F6",
    textIcon: "TB",
    website: "https://theb.ai",
    authHint: "Bearer API key for the TheB.AI OpenAI-compatible gateway.",
    passthroughModels: true,
  },
  bai: {
    id: "bai",
    alias: "bai",
    name: "b.ai",
    icon: "hub",
    color: "#6366F1",
    textIcon: "BA",
    website: "https://b.ai",
    authHint:
      "Bearer API key for the b.ai OpenAI-compatible LLM gateway (distinct from TheB.AI). " +
      "Create a key at https://docs.b.ai, then use https://api.b.ai/v1 as the OpenAI-compatible base URL.",
    passthroughModels: true,
  },
  fenayai: {
    id: "fenayai",
    alias: "fenayai",
    name: "FenayAI",
    icon: "hub",
    color: "#FF9800",
    textIcon: "FN",
    website: "https://fenayai.com",
    authHint: "Bearer API key for the FenayAI OpenAI-compatible gateway.",
    passthroughModels: true,
  },
  empower: {
    id: "empower",
    alias: "empower",
    name: "Empower",
    icon: "hub",
    color: "#14B8A6",
    textIcon: "EM",
    website: "https://docs.empower.dev",
    authHint: "Bearer API key for the Empower OpenAI-compatible endpoint.",
    apiHint:
      "Empower exposes OpenAI-compatible chat on https://app.empower.dev/api/v1 with tool-calling support on empower-functions.",
    passthroughModels: true,
  },
  poe: {
    id: "poe",
    alias: "poe",
    name: "Poe",
    icon: "hub",
    color: "#F97316",
    textIcon: "PO",
    website: "https://creator.poe.com/api-reference",
    authHint: "Bearer API key for the Poe OpenAI-compatible API.",
    apiHint:
      "Poe exposes OpenAI-compatible chat and responses on https://api.poe.com/v1, with authenticated balance checks on /usage/current_balance.",
    passthroughModels: true,
  },
  chutes: {
    id: "chutes",
    alias: "chutes",
    name: "Chutes.ai",
    icon: "hub",
    color: "#06B6D4",
    textIcon: "CH",
    website: "https://chutes.ai",
    hasFree: false,
    freeNote:
      "No free tier as of 2026 — Chutes moved to pay-as-you-go (free Early Access ended 2026-03).",
    authHint: "Bearer API key for the Chutes OpenAI-compatible gateway.",
    passthroughModels: true,
  },
  // Factory AI ("Factory Droids") subscription gateway — the same backend the
  // local `droid` CLI shells into, exposed here as an OpenAI-compatible HTTP
  // endpoint. Auth surface per https://github.com/Factory-AI/droid-sdk-typescript
  // is `FACTORY_API_KEY` (Bearer). Subscription tier uses app.factory.ai quota.
  factory: {
    id: "factory",
    alias: "factory",
    name: "Factory",
    icon: "smart_toy",
    color: "#0F172A",
    textIcon: "FA",
    website: "https://factory.ai",
    authHint: "Bearer API key for the Factory OpenAI-compatible gateway.",
    apiHint:
      "Get your Factory API key at https://app.factory.ai/settings/api-keys, then paste it as a Bearer token. OpenAI-compatible endpoint at https://api.factory.ai/v1.",
    passthroughModels: true,
  },
  bluesminds: {
    id: "bluesminds",
    alias: "bm",
    name: "BluesMinds",
    icon: "psychology",
    color: "#3B82F6",
    textIcon: "BM",
    website: "https://www.bluesminds.com",
    hasFree: true,
    freeNote:
      "Free daily pi credits — supports 200+ models including GPT-4o, GPT-4.1, Claude Sonnet 4.5, Gemini 2.0 Flash, DeepSeek V4, Qwen, Kimi K2",
    apiHint:
      "Get your API key at https://www.bluesminds.com — OpenAI-compatible endpoint at https://api.bluesminds.com/v1 with free daily credits. VIP models (Claude Opus 4.5, Gemini 2.5 Pro) consume pi credits.",
  },
  "freemodel-dev": {
    id: "freemodel-dev",
    alias: "fmd",
    name: "FreeModel.dev",
    icon: "auto_awesome",
    color: "#8B5CF6",
    textIcon: "FM",
    website: "https://freemodel.dev",
    hasFree: true,
    freeNote:
      "$300 free credits on signup — no credit card required. Access GPT-5.4 and GPT-5.5 (OpenAI's latest flagship models) through an OpenAI-compatible API.",
    apiHint:
      "Get $300 free API credits at https://freemodel.dev — no payment info required. OpenAI-compatible endpoint. GPT-5.4 and GPT-5.5 models available.",
  },
  freeaiapikey: {
    id: "freeaiapikey",
    alias: "faik",
    name: "FreeAIAPIKey",
    icon: "vpn_key",
    color: "#F59E0B",
    textIcon: "FK",
    website: "https://freeaiapikey.com",
    apiHint:
      "Discounted API proxy for 40+ models including GPT-5, Claude Opus 4.6, Claude Sonnet 4.6, Qwen 3.5. Get your API key at https://freeaiapikey.com/dashboard. Base URL: https://freeaiapikey.com/v1.",
  },
  zenmux: {
    id: "zenmux",
    alias: "zm",
    name: "ZenMux",
    icon: "neurology",
    color: "#7C3AED",
    textIcon: "ZM",
    website: "https://zenmux.ai",
    hasFree: true,
    freeNote:
      "Free tier includes access to Gemini 3 Flash, DeepSeek V3.2, Grok 4.1 Fast, Mistral Large, and more. Get your API key at https://zenmux.ai.",
    authHint:
      "Use your ZenMux API key in Authorization: Bearer <key>. ZenMux is fully OpenAI-compatible. Base URL: https://zenmux.ai/api/v1.",
    apiHint:
      "ZenMux exposes an OpenAI-compatible chat completions endpoint at /api/v1/chat/completions, plus Anthropic Messages (/api/anthropic/v1/messages) and Google Gemini (/api/vertex-ai) protocol surfaces. OmniRoute uses the OpenAI protocol.",
  },
  openadapter: {
    id: "openadapter",
    alias: "oad",
    name: "OpenAdapter",
    icon: "hub",
    color: "#10B981",
    textIcon: "OD",
    website: "https://openadapter.dev",
    hasFree: true,
    freeNote:
      "Free tier with a generous quota and no credit card — 15+ open-source models with daily quota. Get your API key at https://dashboard.openadapter.in.",
    authHint:
      "Use your OpenAdapter API key in Authorization: Bearer sk-cv-<key>. Fully OpenAI-compatible. API base URL: https://api.openadapter.in/v1.",
    apiHint:
      "OpenAdapter exposes an OpenAI-compatible chat completions endpoint at https://api.openadapter.in/v1/chat/completions, aggregating 70+ open-source models (DeepSeek, Qwen, Kimi, MiniMax, GLM, Llama, Mistral, …). OmniRoute uses the OpenAI protocol.",
  },
  dit: {
    id: "dit",
    alias: "dai",
    name: "DIT.ai",
    icon: "hub",
    color: "#0EA5E9",
    textIcon: "DT",
    website: "https://dit.ai",
    authHint:
      "Use your dit.ai API key in Authorization: Bearer <key>. Fully OpenAI-compatible — a drop-in replacement, just change the base URL to https://api.dit.ai/v1.",
    apiHint:
      "dit.ai (Distributed Intelligence Trade) is an OpenAI-compatible router/gateway with dynamic per-request pricing, exposing /v1/chat/completions at https://api.dit.ai/v1. OmniRoute uses the OpenAI protocol; spend/savings analytics live in the dit.ai dashboard.",
  },
  tokenrouter: {
    id: "tokenrouter",
    alias: "trk",
    name: "TokenRouter",
    icon: "hub",
    color: "#F59E0B",
    textIcon: "TK",
    website: "https://tokenrouter.com",
    hasFree: true,
    freeNote:
      "Free tier includes the MiniMax 3 model. Get your API key at https://tokenrouter.com.",
    authHint:
      "Use your TokenRouter API key in Authorization: Bearer <key>. Fully OpenAI-compatible. API base URL: https://api.tokenrouter.com/v1.",
    apiHint:
      "TokenRouter exposes an OpenAI-compatible chat completions endpoint at https://api.tokenrouter.com/v1/chat/completions, plus a working /v1/models catalog. OmniRoute uses the OpenAI protocol.",
  },
  sumopod: {
    id: "sumopod",
    alias: "sumopod",
    name: "SumoPod",
    icon: "router",
    color: "#2563EB",
    textIcon: "SP",
    passthroughModels: true,
    website: "https://ai.sumopod.com",
    authHint:
      "Use your SumoPod API key (sk-...) in Authorization: Bearer <key>. Fully OpenAI-compatible. API base URL: https://ai.sumopod.com/v1.",
    apiHint:
      "SumoPod exposes an OpenAI-compatible chat completions endpoint at https://ai.sumopod.com/v1/chat/completions, plus a live /v1/models catalog. OmniRoute uses the OpenAI protocol and lists models via passthrough.",
  },
  x5lab: {
    id: "x5lab",
    alias: "x5lab",
    name: "X5Lab",
    icon: "router",
    color: "#7C3AED",
    textIcon: "X5",
    passthroughModels: true,
    website: "https://x5lab.dev",
    authHint:
      "Use your X5Lab API key (x5-...) in Authorization: Bearer <key>. Fully OpenAI-compatible. API base URL: https://api.x5lab.dev/v1.",
    apiHint:
      "X5Lab exposes an OpenAI-compatible chat completions endpoint at https://api.x5lab.dev/v1/chat/completions, plus a live /v1/models catalog. OmniRoute uses the OpenAI protocol and lists models via passthrough.",
  },
  kenari: {
    id: "kenari",
    alias: "kenari",
    name: "Kenari",
    icon: "hub",
    color: "#B5362A",
    textIcon: "KN",
    passthroughModels: true,
    website: "https://kenari.id",
    authHint:
      "Use your Kenari API key (kn-...) in Authorization: Bearer <key>. Fully OpenAI-compatible. API base URL: https://kenari.id/v1.",
    apiHint:
      "Kenari exposes an OpenAI-compatible chat completions endpoint at https://kenari.id/v1/chat/completions, plus a live /v1/models catalog covering Claude, GPT, DeepSeek, GLM, Kimi and more. OmniRoute uses the OpenAI protocol and lists models via passthrough.",
  },
};
